var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/* eslint-disable react-hooks/exhaustive-deps */
import CloseIcon from "@mui/icons-material/Close";
import SearchIcon from "@mui/icons-material/Search";
import { Button, IconButton, InputBase, Paper } from "@mui/material";
import { useEffect, useState } from "react";
export var Search = function (_a) {
    var onSearch = _a.onSearch, onClearSearch = _a.onClearSearch, _b = _a.text, text = _b === void 0 ? "" : _b;
    var _c = useState(text), input = _c[0], setInput = _c[1];
    var handleSubmit = function (e) {
        e.preventDefault();
        if (input.length >= 3) {
            onSearch(input);
        }
    };
    useEffect(function () {
        if (!input)
            onClearSearch();
    }, [input]);
    return (_jsxs(Paper, __assign({ component: "form", onSubmit: handleSubmit, sx: {
            p: "2px 4px",
            display: "flex",
            alignItems: "center",
            width: { md: "60%", xs: "90%" },
        } }, { children: [_jsx(IconButton, __assign({ sx: { p: "10px" }, "aria-label": "menu" }, { children: _jsx(SearchIcon, {}) })), _jsx(InputBase, { sx: { ml: 1, flex: 1 }, placeholder: "Qual servi\u00E7o voc\u00EA procura?", inputProps: { "aria-label": "search", maxLength: 200 }, onChange: function (e) { return setInput(e.target.value); }, value: input }), input && (_jsx(Button, __assign({ startIcon: _jsx(CloseIcon, {}), variant: "text", color: "primary", sx: { mr: "16px" }, onClick: function () {
                    setInput("");
                    onClearSearch();
                } }, { children: "Limpar" }))), _jsx(Button, __assign({ disabled: (input === null || input === void 0 ? void 0 : input.length) < 3 || !input.trim(), type: "submit", sx: { p: "10px" }, variant: "contained", color: "primary" }, { children: "Buscar" }))] })));
};
